import React, { ReactNode } from 'react';

import styled, { css, keyframes } from 'styled-components';

import PersonalRecommend from './PersonalRecommend.jsx';
import PersonalRecommend2 from './PersonalRecommend2.jsx';
import IssueContents from './IssueContents.jsx';
import IssueContents2 from './IssueContents2.jsx';
import IssueContents3 from './IssueContents3.jsx';
import { mainState } from '../../modules/main';
import { searchKeywordState } from '../../modules/searchKeyword';
import { media } from '../common/Layout';
import {
  TravelInfoImageResult,
  RecommendedInfoImageResult,
} from '../../lib/main/type.js';
import { PostConsumptionBodyType } from '../../lib/common/type.js';

const ContentSetting01Component = styled.div`
  width: 100%;
  background-color: #f0f4fb;
  display: flex;
  flex-direction: column;
`;

const CopyRight = styled.div`
  display: flex;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1070px;
  padding: 0 16px 0 16px;

  /* Mobile Device */
  margin-top: 33px;
  margin-bottom: 36px;

  ${media.desktop`  
    margin-top: 30px;
    margin-bottom: 90px;
  `};
`;
const CopyRightText = styled.div`
  font-family: 'NotoKrL';
  color: #666666;

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop`  
    font-size: 16px;
  `};
`;

interface ContentSetting01Props {
  onPostConsumption: (info: PostConsumptionBodyType) => void;
  totalRecommendData: mainState['totalRecommendData'];
  popularContentsData: mainState['popularContentsData'];
  wordCloudData: mainState['wordCloudData'];
}

interface ContentSetting01State {}
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

class ContentSetting01 extends React.PureComponent<
  ContentSetting01Props,
  ContentSetting01State
> {
  componentDidMount() {
    window.addEventListener('resize', () => {
      if (!isMobile()) {
        window.location.reload();
      }
    });
  }

  deduplicationData = (): ReactNode[] | null => {
    const {
      totalRecommendData,
      popularContentsData,
      wordCloudData,
      onPostConsumption,
    } = this.props;
    const resultReactNode: ReactNode[] | null = [];
    const popularContentsReactNode: ReactNode[] | null = [];
    const TravelImageArray: TravelInfoImageResult[] = [];
    const RecommendImageArray: RecommendedInfoImageResult[] = [];
    let isSame = false;
    let isWordCloudProps = false;

    // 여행지 데이터 확인(토탈추천)
    if (totalRecommendData && totalRecommendData.travel_info_image) {
      totalRecommendData.travel_info_image.results.forEach((element) => {
        if (TravelImageArray) {
          isSame = false;
          TravelImageArray.some((tempElement) => {
            if (element.cot_id === tempElement.cot_id) {
              isSame = true;
              return true;
            }
            return false;
          });
        }
        if (!isSame) {
          TravelImageArray.push(element);
        }
      });
    }

    // 여행지 추천 데이터 확인(토탈추천)
    if (totalRecommendData && totalRecommendData.recommended_info_image) {
      totalRecommendData.recommended_info_image.results.forEach((element) => {
        if (RecommendImageArray) {
          isSame = false;
          RecommendImageArray.some((tempElement) => {
            if (element.cot_id === tempElement.cot_id) {
              isSame = true;
              return true;
            }
            return false;
          });
        }
        if (!isSame) {
          RecommendImageArray.push(element);
        }
      });
    }

    // 여행지 데이터 확인(인기콘텐츠)
    if (popularContentsData && popularContentsData.travel_info) {
      if (!isWordCloudProps) {
        popularContentsReactNode.push(
          <IssueContents
            onPostConsumption={onPostConsumption}
            wordCloudData={wordCloudData}
            popularContentsData={popularContentsData}
          />
        );
        isWordCloudProps = true;
      }
    }

    // 여행지 추천 데이터 확인(인기콘텐츠)
    if (popularContentsData && popularContentsData.recommended_info) {
      if (!isWordCloudProps) {
        popularContentsReactNode.push(
          <IssueContents2
            onPostConsumption={onPostConsumption}
            wordCloudData={wordCloudData}
            popularContentsData={popularContentsData}
          />
        );
        isWordCloudProps = true;
      } else {
        popularContentsReactNode.push(
          <IssueContents2
            popularContentsData={popularContentsData}
            onPostConsumption={onPostConsumption}
          />
        );
      }
    }

    // 코스 데이터 확인(인기콘텐츠)
    if (popularContentsData && popularContentsData.course_info) {
      if (!isWordCloudProps) {
        popularContentsReactNode.push(
          <IssueContents3
            onPostConsumption={onPostConsumption}
            wordCloudData={wordCloudData}
            popularContentsData={popularContentsData}
          />
        );
        isWordCloudProps = true;
      } else {
        popularContentsReactNode.push(
          <IssueContents3
            popularContentsData={popularContentsData}
            onPostConsumption={onPostConsumption}
          />
        );
      }
    }

    resultReactNode.push(
      <>
        <PersonalRecommend
          onPostConsumption={onPostConsumption}
          totalRecommendData={totalRecommendData}
          TravelImageArray={TravelImageArray}
        />
        <PersonalRecommend2
          onPostConsumption={onPostConsumption}
          totalRecommendData={totalRecommendData}
          RecommendImageArray={RecommendImageArray}
        />
      </>
    );

    return resultReactNode.concat(popularContentsReactNode);
  };

  render() {
    return (
      <ContentSetting01Component>
        {this.deduplicationData()}

        <CopyRight>
          <CopyRightText>
            Copyright 2020. Nerdfactory. All rights reserved.
          </CopyRightText>
        </CopyRight>
      </ContentSetting01Component>
    );
  }
}

export default ContentSetting01;
